import { render } from "./MarkIcon.vue?vue&type=template&id=33afa546&scoped=true"
const script = {}

import "./MarkIcon.vue?vue&type=style&index=0&id=33afa546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33afa546"]])

export default __exports__